import React from 'react'
import { DownOutlined } from '@ant-design/icons'
import { toGroupKey, type TableRow } from './groupInvoicePeriods'
import styles from './InvoiceList.module.scss'

interface InvoicePeriodCellProps {
  record: TableRow
  isExpanded: boolean
  onTogglePeriod: (groupKey: string) => void
}

export const InvoicePeriodCell = ({
  record,
  isExpanded,
  onTogglePeriod,
}: InvoicePeriodCellProps) => {
  if (record.rowKind === 'version') {
    return (
      <span className={styles.olderLabel}>
        <span aria-hidden>|</span>
        Version {record.version}
      </span>
    )
  }

  const versionCount = record.olderVersions.length + 1
  const hasOlder = record.olderVersions.length > 0
  return (
    <div className={styles.periodCell}>
      {hasOlder ? (
        <button
          type="button"
          className={styles.expandButton}
          aria-expanded={isExpanded}
          aria-label={
            isExpanded
              ? `Hide older versions for ${record.period}`
              : `Show ${record.olderVersions.length} older ${
                  record.olderVersions.length === 1 ? 'version' : 'versions'
                } for ${record.period}`
          }
          onClick={() => onTogglePeriod(toGroupKey(record))}
        >
          <span
            className={
              isExpanded ? styles.chevronExpanded : styles.chevronCollapsed
            }
          >
            <DownOutlined />
          </span>
        </button>
      ) : (
        <span className={styles.expandSpacer} aria-hidden />
      )}
      <span className={styles.periodName}>
        {hasOlder ? `${record.period} (${versionCount})` : record.period}
        {hasOlder ? <span className={styles.latestTag}>Latest</span> : null}
      </span>
    </div>
  )
}
